/* eslint-disable import/no-cycle */
import {computed, decorate, observable} from 'mobx';
import * as moment from 'moment';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {WorkplaceStateLog} from '../models/workplaceStateLog';

export class WorkplaceStateLogStore extends EntityStore {
  logs = [];
  selected = null;

  constructor(rootStore) {
    super(rootStore, 'logs', Api.workplaceStateLogs, WorkplaceStateLog);
  }

  getDependencies() {
    return [
      {
        store: this.rootStore.workplaceStateStore,
        modelId: 'stateId',
      },
    ];
  }

  loadManyByWorkplace(workplaceId, {fromDate, toDate, isInterruption, interruptionReasonId}) {
    return this.loadAllWithDependencies({
      params: {
        workplaceId,
        fromDate: fromDate.toDate(),
        toDate: toDate.toDate(),
        isInterruption,
        interruptionReasonId,
      },
    });
  }

  getByWorkplaceId(workplaceId) {
    return this.logs.filter((log) => log.workplaceId === workplaceId);
  }

  getLatestOfWorkplace(workplaceId) {
    const wpLogs = this.getByWorkplaceId(workplaceId);
    return wpLogs.reduce((newest, next) => {
      if (!newest || newest.start < next.start) {
        return next;
      }
      return newest;
    }, null);
  }

  getUnclassifiedByWorkplaceId(workplaceId) {
    return this.logs.filter((log) => log.workplaceId === workplaceId
      && log.state?.isInterruption && !log.interruptionReasonId);
  }

  getByStateIdAndWorkplaceId(stateId, workplaceId) {
    return this.logs.filter((log) => log.stateId === stateId && log.workplaceId === workplaceId);
  }

  getLatestByStateAndWorkplace(stateId, workplaceId) {
    const wpLogs = this.getByStateIdAndWorkplaceId(stateId, workplaceId);
    return wpLogs.reduce((newest, next) => {
      if (!newest || newest.start < next.start) {
        return next;
      }
      return newest;
    }, null);
  }

  get latestBySelectedWorkplace() {
    if (this.rootStore.workplaceStore.selectedWorkplace) {
      const wpLogs = this.getByWorkplaceId(this.rootStore.workplaceStore.selectedWorkplace.id);
      return wpLogs.reduce((newest, next) => {
        if (!newest || newest.start < next.start) {
          return next;
        }
        return newest;
      }, null);
    }
    return null;
  }

  getByWorkplaceIdIgnoreShortInterruptions(workplaceId, minInterruptionDuration) {
    if (minInterruptionDuration > 0) {
      return this.logs.filter((log) =>
        log.workplaceId === workplaceId
        && (!log.state?.isInterruption || !log.end
          || moment(log.end).diff(moment(log.start), 'seconds') > minInterruptionDuration
        ))
        .sort((a, b) => moment(a.start) - moment(b.start))
        .map((log, index, logs) => {
          const current = {...log};
          let i = index + 1;
          let next = logs[i];
          while (next && log.stateId === next.stateId) {
            current.end = next.end;
            next.remove = true;
            next = logs[i++]; // eslint-disable-line no-plusplus
          }
          return current;
        }).filter((log) => !log.remove);
    }
    return this.logs.filter((log) => log.workplaceId === workplaceId);
  }
}

decorate(WorkplaceStateLogStore, {
  selected: observable,
  logs: observable,
  latestBySelectedWorkplace: computed,
});
